import $ from "jquery";
import { getTextNodesIn } from "./get-text-nodes";

export function restoreSelectionFromElementChilds(selection, element) {}

export function restoreSelectionFromNodeList(document, selection, nodes) {
  var first, last;
  if (nodes instanceof $) {
    first = nodes.first()[0];
    last = nodes.last()[0];
  } else {
    first = nodes[0];
    last = nodes[nodes.length - 1];
  }
  const rangeNew = document.createRange();

  if (first.nodeType === Node.TEXT_NODE) {
    rangeNew.setStart(first, 0);
  } else {
    rangeNew.setStart(getTextNodesIn(first, true)[0], 0);
  }

  if (last.nodeType === Node.TEXT_NODE) {
    rangeNew.setEnd(last, last.length);
  } else {
    const textNodes = getTextNodesIn(last, true);
    rangeNew.setEnd(
      textNodes[textNodes.length - 1],
      textNodes[textNodes.length - 1].length,
    );
  }

  selection.removeAllRanges();
  selection.addRange(rangeNew);
}
